import { useAuth } from '../contexts/AuthContext';

export function UnauthorizedPage() {
  const { signOut } = useAuth();

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <h1>Access denied</h1>
        <p className="auth-subtitle">
          This account does not have ADMIN, SUPPORT, or LEAD_SPECIALIST access.
          If you believe this is a mistake, contact an administrator.
        </p>
        <button type="button" onClick={() => void signOut()}>
          Back to sign in
        </button>
      </div>
    </div>
  );
}
